import React, { useState } from "react";
import "./EmployeeDetails.css";
import "../Dashboard/Dashboard.css";
import { useLocation, useNavigate } from "react-router-dom";
import Gbtn from "../../Components/buttons/Gbtn";
import DashNav from "../../Components/DashNav/DashNav";
import EmployeeSVG from "../../Components/SVGS/EmployeeSVG";
import { FaEyeSlash } from "react-icons/fa";
import SuppliersSVG from "../../Components/SVGS/SuppliersSVG";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";

function EmployeeDetails({ isSupDetails }) {
  const icon = () => {
    return isSupDetails ? (
      <SuppliersSVG size="22" fill="black" />
    ) : (
      <EmployeeSVG size="22" fill="black" />
    );
  };
  const location = useLocation();
  const emp = location.state.empDetails;
  const employee = emp.employee;
  const supplier = location.state.supDetails;

  const navigate = useNavigate();
  const editOnclick = () => {
    isSupDetails
      ? navigate("/dashboard/employees/supplierEdit", {
          state: { supplierToEdit: supplier },
        })
      : navigate("/dashboard/employees/empEdit", {
          state: { employeeToEdit: emp },
        });
  };

  //Toast messages
  const showMessage = (cat) => {
    cat === 0
      ? toast.success("Employee Deleted Successfuly!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        })
      : cat === 1
      ? toast.error("Employee Not Deleted! Some Error occurred", {
          position: toast.POSITION.BOTTOM_RIGHT,
        })
      : toast.error("Network Error!", {
          position: toast.POSITION.TOP_CENTERR,
        });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isErr, setIsErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const delOnclick = () => {
    setIsErr(false);
    setIsLoading(true);

    let reqObj = {
      id: employee.id,
    };

    // deleteEmployee(reqObj).then(({data})=>{
    //   setIsLoading(false)
    //   console.log('dell',data)
    //   if (data.success){
    //     showMessage(0)
    //     navigate('/dashboard/employees')
    //   }
    //   else{
    //     showMessage(1)
    //     setIsErr(true)
    //     setErrMsg(data.message)
    //   }
    // }).catch((err)=>{
    //   showMessage(2)
    //   setIsLoading(false)
    //   setIsErr(true)
    //   setErrMsg(err.message)
    // })
  };
  const age = (dob) => {
    let today = new Date();
    let birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    return age;
  };
  return (
    <>
      <div className="mainDashView">
        <div>
          <DashNav
            svg={icon}
            DashboardNavText={
              isSupDetails
                ? `Suppliers > ${supplier.company}`
                : `Employee Details > ${emp.name}`
            }
          />
        </div>
        <div className="ev dashPanel">
          {isLoading ? (
            <div style={{ width: "100%", textAlign: "center" }}>
              <LoadingSpinner />
            </div>
          ) : (
            <div className="ev-data">
              <div
                style={{
                  color: "red",
                  display: isErr ? "flex" : "none",
                  textAlign: "center",
                }}
              >
                Error! {errMsg}
              </div>
              <div className="ev-info">
                <span className="spanHead">
                  {isSupDetails ? "Company" : "First Name"}
                </span>
                <span className="spanInfo">
                  {isSupDetails ? supplier.company : employee.first_name}
                </span>
              </div>
              <div className="ev-info">
                <span className="spanHead">
                  {isSupDetails ? "Brand Name" : "Last Name"}
                </span>
                <span className="spanInfo">
                  {isSupDetails ? supplier.brandName : employee.last_name}
                </span>
              </div>
              {isSupDetails ? (
                <div className="ev-info">
                  <span className="spanHead">Vat Number</span>
                  <span className="spanInfo">
                    {isSupDetails ? supplier.vatNumber : ""}
                  </span>
                </div>
              ) : null}
              <div className="ev-info">
                <span className="spanHead">Email</span>
                <span className="spanInfo">
                  {isSupDetails ? supplier.email : emp.email}
                </span>
              </div>
              <div className="ev-info">
                <span className="spanHead">Gender</span>
                <span className="spanInfo">
                  {isSupDetails
                    ? supplier.mobile
                    : employee.gender === 1
                    ? "Male"
                    : "Female"}
                </span>
              </div>
              <div className="ev-info">
                <span className="spanHead">
                  {isSupDetails ? "Adress" : "Salary"}
                </span>
                <span className="spanInfo">
                  {isSupDetails ? supplier.adress : employee.salary}
                </span>
              </div>
              <div className="ev-info">
                <span className="spanHead">
                  {isSupDetails ? "City" : "Age"}
                </span>
                <span className="spanInfo">
                  {isSupDetails ? supplier.city : age(employee.dob)}
                </span>
              </div>
              {isSupDetails ? (
                <div className="ev-info">
                  <span className="spanHead">{"State"}</span>
                  <span className="spanInfo">{supplier.state}</span>
                </div>
              ) : null}
              <div className="ev-info">
                <span className="spanHead">
                  {isSupDetails ? "Postal Code" : "Role"}
                </span>
                <span className="spanInfo">
                  {isSupDetails ? supplier.postalCode : "Employee"}
                </span>
              </div>
              <div className="ev-info">
                <span className="spanHead">
                  {isSupDetails ? "Company Description" : "Status"}
                </span>
                <span className="spanInfo">
                  {isSupDetails
                    ? supplier.description
                    : employee.status === 1
                    ? "Active"
                    : "Disable"}
                </span>
              </div>
            </div>
          )}
          <div className="ev-buttons">
            <div className="ev-btnAdd ev-btn">
              <Gbtn
                text="Edit"
                color="#4ab493"
                func={editOnclick}
                radius="13px"
                width="130px"
              />
            </div>
            <div className="ev-btnDel ev-btn">
              <Gbtn
                text="Delete"
                color="#F39971"
                func={delOnclick}
                radius="13px"
                width="130px"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeDetails;
